module.exports = function getResource(label, vars = []) {
    let resources = {
        welcomeTo: 'Bienvenue chez',
        beautyInsider: 'Beauty Insider',
        joinNow: 'S’inscrire'
    };

    return resources[label];
};
